import { useLazyQuery } from "@apollo/client";
import SearchBox from "components/SearchBox";
import Table from "components/Table";
import { ROW_PER_PAGE_OPTIONS } from "config";
import useText from "constants/text";
import { useModalColumns } from "domains/CashManagement/data";
import { useCashStyles } from "domains/CashManagement/style";
import { FilterRecapParcelProps } from "domains/CashManagement/types";
import { Parcel } from "generated/graphql";
import { GET_PARCELS_BY_IDS } from "graphql/cashManagement/queries";
import React from "react";
import Dialog from "ui/Dialog";
import { isSuccess } from "utils/https";

const rowsPerPageLimit = 10;
function ParcelModal({ open, onConfirm, onClose, parcelIds, setHasFilters, remittanceUid}: FilterRecapParcelProps) {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState<number>();
  const [countTotal, setCountTotal] = React.useState<number>();
  const [parcels, setParcels] = React.useState<Parcel[]>();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const columns = useModalColumns();
  const classes = useCashStyles();
  const { text } = useText();

  const [getParcelsByIds, { loading }] = useLazyQuery(GET_PARCELS_BY_IDS, {
    onCompleted: (data) => {
      if (isSuccess(data)) {
        setParcels(data?.results?.data);
      }
    },
    fetchPolicy: "cache-and-network",
  });
 
  React.useEffect(()=>{
    getParcelsByIds({
      variables:{
        queries:{
          ids: parcelIds
        }
      }
    });
    open && setSearchTerm("")
  },[parcelIds])


  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleSearchTerm = (event:any)=>{
    setSearchTerm(event.target.value);
}

  return (
    <div >
      <div>
        <Dialog
          open={open}
          customDialogTitle={<span className={classes.dialogTitle}>{text.cash_management.remittance} <span className={classes.remittanceUid}> {remittanceUid} :</span> <span className={classes.parcelCount}>{parcelIds?.length} Parcels</span></span>}
          confirmButtonTitle={text.all.confirm}
          cancelButtonTitle={text.all.cancel}
          handleClose={onClose}
          handleConfirm={handleConfirm}
          maxWidth="lg"
          removeBottomBar      
        >
          
        <div className={classes.search}>
        <SearchBox
          onChange={handleSearchTerm}
          value={searchTerm}
          css={`
            .MuiInputBase-input {
              height: 1rem;
            }
          `}
        />
        </div>

          <div className={classes.table}>
              <Table
                searchTerm={searchTerm}
                rowsIdentifier="parcel_UID"
                columns={columns}
                isLoading={loading}
                data={parcels}
                rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
                rowsPerPage={rowsPerPage}
                currentPage={page}
                countTotal={countTotal}
                setRowsPerPage={setRowsPerPage}
              />
            </div>
          
        </Dialog>
      </div>
    </div>
  );
}

export default ParcelModal;
